module.exports = __webpack_public_path__ + "img/mimg01.0181ed02.jpg";